module.exports = __webpack_public_path__ + "static/media/alert-circle.411a8c52.svg";